import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import moment from 'moment';

import Icon from 'components/Icon';
import { createSchedule, getSchedules } from 'redux/actions/scheduleActions';
import ScheduleForm from './ScheduleForm';


class ScheduleCreate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    createSchedule: PropTypes.func.isRequired,
    getSchedules: PropTypes.func.isRequired,
    accountId: PropTypes.number.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  async onSubmit(formData) {
    try {
      await this.props.createSchedule({
        name: formData.name,
        account: this.props.accountId,
        monday: formData.days_to_send.includes('monday'),
        tuesday: formData.days_to_send.includes('tuesday'),
        wednesday: formData.days_to_send.includes('wednesday'),
        thursday: formData.days_to_send.includes('thursday'),
        friday: formData.days_to_send.includes('friday'),
        saturday: formData.days_to_send.includes('saturday'),
        sunday: formData.days_to_send.includes('sunday'),
        time_from: moment(formData.time_from).format('HH:mm:ss'),
        time_to: moment(formData.time_to).format('HH:mm:ss'),
        exclude_us_holidays: formData.exclude_us_holidays,
        excluded_dates: formData.excluded_dates,
        timezone: formData.timezone.value,
      });
      await this.props.getSchedules({ account__id: this.props.accountId }, true);
      this.toggle();
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <Icon className="add-schedule__icon" name="plus-circle" onClick={this.toggle} />
        <Dialog open={this.state.isOpen} onBackdropClick={this.toggle} size="large">
          <DialogTitle disableTypography>Add Schedule</DialogTitle>
          <ScheduleForm toggleModal={this.toggle} onSubmit={data => this.onSubmit(data)} />
        </Dialog>
      </div>
    );
  }
}

export default compose(
  connect(
    null,
    { createSchedule, getSchedules },
  ),
  withNamespaces('common'),
)(ScheduleCreate);
